"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validation = exports.sanitization = void 0;
var utils_1 = require("../utils");
exports.sanitization = {
    type: 'string',
    maxLength: utils_1.MAX_STR_LENGTH,
    rules: [
        'trim'
    ],
};
exports.validation = {
    type: 'string',
    optional: true,
    minLength: 1,
};
